/**
 * O ícone do leitor: os quatro cantos da mira, um QR e a linha de leitura.
 *
 * Desenhado em vetor a partir do ícone escolhido para o botão da câmera — as
 * posições foram medidas na imagem de referência (em unidades de 0 a 100), e
 * não redesenhadas de olho. Vetor para ficar nítido em qualquer tamanho e
 * receber a cor do tema, como os ícones do lucide.
 */

import React from 'react';
import {Path, Rect, Svg} from 'react-native-svg';

/** Módulos do QR: [x, y, largura, altura]. As peças em L e em escada são uniões. */
const MODULOS: Array<[number, number, number, number]> = [
  // Escada de cima, entre os dois quadrados de canto.
  [44.9, 26.9, 5, 6.7],
  [44.9, 30.2, 10.2, 3.4],
  [51.4, 30.2, 3.7, 7.8],
  [44.9, 37.2, 4.9, 7.7],
  [51.3, 41.1, 3.8, 3.8],
  // Abaixo da linha de leitura.
  [44.9, 54.1, 6.5, 4],
  [48.4, 54.1, 3, 7.3],
  [48.4, 60.4, 8.2, 1],
  [51.9, 60.4, 4.7, 4.8],
  [56.8, 54.1, 5.1, 4.8],
  [66.6, 54.3, 5, 4.8],
  [61.8, 60.4, 5, 5.3],
  [56.7, 65.9, 5, 6.1],
  [45, 63.3, 4.6, 9.2],
  [45, 67.8, 7.9, 4.7],
  [70, 62.6, 4.6, 9.6],
  [64.5, 68.2, 10.1, 4],
];

/** Quadrados de canto do QR: [x, y] do canto do anel (o miolo vem dele). */
const QUADRADOS_DE_CANTO: Array<[number, number]> = [
  [24.8, 26.9],
  [57.1, 26.9],
  [24.8, 54.4],
];

const CANTOS_DA_MIRA = [
  'M14 32.2V24a8 8 0 0 1 8-8h8.7',
  'M69.3 16H78a8 8 0 0 1 8 8v8.2',
  'M14 67.7v8.1a8 8 0 0 0 8 8h8.8',
  'M86 67.8v8a8 8 0 0 1-8 8h-8.8',
];

export function IconeLeitor({tamanho = 32, cor}: {tamanho?: number; cor: string}) {
  return (
    <Svg width={tamanho} height={tamanho} viewBox="0 0 100 100">
      {CANTOS_DA_MIRA.map(d => (
        <Path
          key={d}
          d={d}
          fill="none"
          stroke={cor}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}

      <Path d="M20 50H80" stroke={cor} strokeWidth={3.3} strokeLinecap="round" />

      {QUADRADOS_DE_CANTO.map(([x, y]) => (
        <React.Fragment key={`${x}-${y}`}>
          {/* Anel de 18 de lado e traço de 2,9: o traço fica centrado na borda. */}
          <Rect
            x={x + 1.45}
            y={y + 1.45}
            width={15.1}
            height={15.1}
            rx={3}
            fill="none"
            stroke={cor}
            strokeWidth={2.9}
          />
          <Rect x={x + 5.3} y={y + 5.6} width={7.5} height={7.3} rx={1} fill={cor} />
        </React.Fragment>
      ))}

      {MODULOS.map(([x, y, largura, altura]) => (
        <Rect key={`${x}-${y}`} x={x} y={y} width={largura} height={altura} rx={0.5} fill={cor} />
      ))}
    </Svg>
  );
}
